/**
 * @file IconTipWarn Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-tip-warn',
  (data) => `
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg
  width="${data.size}"
  height="${data.size}"
  class="icon"
  p-id="9827"
  t="1681968572604"
  viewBox="0 0 1075 1024"
>
  <path
    fill="${data.colorDesc[0]}"
    d="M538.2656 0c-282.7776 0-512 229.2224-512 512 0 282.7264 229.2736 512 512 512 282.7776 0 512-229.2736 512-512 0-282.7776-229.2224-512-512-512z m0 800a64 64 0 1 1 0.0512-128 64 64 0 0 1 0 128z m64-281.6c0 31.7952-28.672 57.6-64 57.6s-64-25.8048-64-57.6v-268.8c0-31.8464 28.672-57.6 64-57.6s64 25.7536 64 57.6v268.8z"
    p-id="9828"
  />
</svg>
`
);
